<template>
  <nav-submenu label="Areas">
    <b-dropdown-item to="/areas">IFAC Technical Areas</b-dropdown-item>
    <b-dropdown-item v-if="permissions.canEditStructure" to="/areas/edit">
      Edit Structure
    </b-dropdown-item>
    <b-dropdown-item v-if="permissions.canEditKeywords" to="/areas/edit-keywords">
      Review Keywords
    </b-dropdown-item>
    <b-dropdown-item v-if="permissions.canValidate" to="/areas/validate">
      Validate Areas
    </b-dropdown-item>
  </nav-submenu>
</template>

<script>
import Revisions from '@/services/Api/TechnicalAreas/Revisions';
import NavSubmenu from '@/views/components/nav/NavSubmenu.vue';

export default {
  name: 'AreasNavItem',
  components: { NavSubmenu },
  data() {
    return {
      permissions: {
        canEditStructure: false,
        canEditKeywords: false,
        canValidate: false,
      },
    };
  },
  async created() {
    try {
      const response = await Revisions.permissions();
      this.permissions = response.data.data;
    } catch (error) {
      if (error.response?.status !== 403) {
        throw error;
      }
    }
  },
};
</script>
